module.exports = __webpack_public_path__ + "static/media/pga-logo.984f34c1.svg";